__turbopack_context__.v({
  "connect": "AuthTerms-module-scss-module__zAx9Oa__connect",
  "moon": "AuthTerms-module-scss-module__zAx9Oa__moon",
  "moonAnimation": "AuthTerms-module-scss-module__zAx9Oa__moonAnimation",
});
